import { faWarning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Center, Stack, Title } from '@mantine/core'

function ErrorPage() {
  return (
    <Center h="100%">
      <Stack align="center">
        <FontAwesomeIcon
          icon={faWarning}
          color="orange"
          style={{ height: '100px' }}
        />
        <Title>An Error Occurred</Title>
        <Title size="h3">Please refresh the page</Title>
      </Stack>
    </Center>
  )
}

export default ErrorPage
